'use client';

import { usePathname } from 'next/navigation';

interface ConditionalLayoutProps {
  children: React.ReactNode;
}

export function ConditionalLayout({ children }: ConditionalLayoutProps) {
  const pathname = usePathname();
  const isHomePage = pathname === '/';

  return (
    <div
      className={`flex min-h-screen flex-col ${
        !isHomePage ? "bg-background" : ""
      }`}
    >
      {children}
    </div>
  );
}
